import createVueApp from '@/common/create_app'

Styxie.Initializers.AdminCustomAlerts = {
  index: async(props) => {
    const { default: IndexPage } = await import('@/vue_widgets/admin/custom_alerts/index.vue')
    createVueApp(IndexPage, { props })
  },
  new: async(props) => {
    const { default: NewPage } = await import('@/vue_widgets/admin/custom_alerts/new.vue')
    createVueApp(NewPage, { props })
  },
  edit: async(props) => {
    const { default: EditPage } = await import('@/vue_widgets/admin/custom_alerts/edit.vue')
    createVueApp(EditPage, { props })
  }
}
